import { IconComponentProps } from '../IconTypes';

const NexelemLogo = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="21" viewBox="0 0 35 31" width="35" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1192_5942)">
      <path d="M34.5097 25.46H17.6297V30.5H34.5097V25.46Z" fill="#23A060" />
      <path
        d="M28.7597 17.0599H11.0497C9.52967 17.0599 8.12967 17.8699 7.36967 19.1899L0.84967 30.4999H6.67967L11.5097 22.0999H28.7597V17.0599Z"
        fill="url(#paint0_linear_1192_5942)"
      />
      <path d="M17.7297 0.209961H0.84967V5.24996H17.7297V0.209961Z" fill="#62BB94" />
      <path
        d="M6.66968 13.64H24.3797C25.8997 13.64 27.2997 12.83 28.0597 11.51L34.5797 0.199951H28.7497L23.9197 8.59995H6.66968V13.64Z"
        fill="#62BB94"
      />
      <path
        d="M24.3797 13.63C25.8997 13.63 27.3097 12.82 28.0697 11.5L32.1897 4.35999C30.6397 6.97999 27.8197 8.59999 24.7697 8.59999H6.67966V13.64H24.3797V13.63Z"
        fill="url(#paint1_linear_1192_5942)"
      />
      <path
        d="M11.0597 17.0699C9.53967 17.0699 8.12967 17.8799 7.37967 19.1999L3.25967 26.3399C4.80967 23.7199 7.62967 22.0999 10.6797 22.0999H28.7697V17.0599H11.0597V17.0699Z"
        fill="url(#paint2_linear_1192_5942)"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_1192_5942"
        x1="11.6397"
        x2="16.8397"
        y1="16.6699"
        y2="28.3499"
      >
        <stop stopColor="#1D6F6B" />
        <stop offset="0.32" stopColor="#208467" />
        <stop offset="0.7" stopColor="#23A060" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_1192_5942"
        x1="8.66966"
        x2="30.5997"
        y1="5.11999"
        y2="13.02"
      >
        <stop offset="0.1" stopColor="#5BB677" />
        <stop offset="0.48" stopColor="#3CAD59" />
        <stop offset="1" stopColor="#3CAD59" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_1192_5942"
        x1="6.13967"
        x2="28.7697"
        y1="18.8199"
        y2="25.4199"
      >
        <stop offset="0.1" stopColor="#5BB677" />
        <stop offset="0.48" stopColor="#3CAD59" />
        <stop offset="1" stopColor="#3CAD59" />
      </linearGradient>
      <clipPath id="clip0_1192_5942">
        <rect fill="white" height="30.29" transform="translate(0.84967 0.209961)" width="33.66" />
      </clipPath>
    </defs>
  </svg>
);

export default NexelemLogo;
